import { Row } from 'antd';
import LogoIcon from 'app/components/Sidebar/icons/LogoIcon';
import LogoTextIcon from 'app/components/Sidebar/icons/LogoTextIcon';
import styled from 'styled-components';
import { cssMediaBreakpoints } from 'utils/responsiveQuery/breakpoints';

export const LogoRow = styled(Row)`
  margin-top: 89px;
  margin-bottom: 50px;
  height: 64px;
  display: flex;
  align-items: center;
`;

export const Logo = styled(LogoIcon)`
  margin-right: 14px;
  width: 46px;
  height: 49px;
`;

export const LogoText = styled(LogoTextIcon)`
  width: 98px;
  height: 32px;
`;

export const MainRow = styled(Row)`
  padding-bottom: 100px;
`;

export const LayoutWrapper = styled.div`
  background: ${p => p.theme.background};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 24px;
  ${cssMediaBreakpoints.smallMobile} {
    padding: 12px;
  }
`;
